(function () {
  'use strict';

  const motionPreference = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  function applyState(root) {
    if (!root) return;

    const enabled =
      root.dataset.animate !== 'false';

    if (
      !enabled ||
      motionPreference.matches
    ) {
      root.classList.remove('iq-running');
      return;
    }

    root.classList.add('iq-running');
  }

  function init(root) {
    if (!root) return;

    if (
      root.dataset.iqInitialized === 'true'
    ) {
      applyState(root);
      return;
    }

    root.dataset.iqInitialized = 'true';

    if (
      root.dataset.animate === 'false' ||
      motionPreference.matches
    ) {
      applyState(root);
      return;
    }

    if ('IntersectionObserver' in window) {

      const observer =
        new IntersectionObserver(
          (entries) => {

            const visible =
              entries.some(
                entry =>
                  entry.isIntersecting
              );

            if (!visible) return;

            applyState(root);

            observer.disconnect();

          },
          {
            threshold: 0.08
          }
        );

      root.iqObserver = observer;

      observer.observe(root);

    } else {

      applyState(root);

    }
  }

  function initAll(scope = document) {

    if (
      scope.matches?.('[data-iq-motion]')
    ) {
      init(scope);
    }

    scope
      .querySelectorAll?.('[data-iq-motion]')
      .forEach(init);
  }

  function refreshAll() {

    document
      .querySelectorAll('[data-iq-motion]')
      .forEach(applyState);
  }

  window.IQBundleMotion = {
    initAll,
    refreshAll
  };

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => initAll(),
      {
        once: true
      }
    );

  } else {

    initAll();

  }

  document.addEventListener(
    'shopify:section:load',
    event => {
      initAll(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    event => {

      event.target
        .querySelectorAll?.('[data-iq-motion]')
        .forEach(root => {

          root.iqObserver?.disconnect();

        });

    }
  );

  const preferenceChanged = () => {
    refreshAll();
  };

  if (
    typeof motionPreference.addEventListener ===
    'function'
  ) {

    motionPreference.addEventListener(
      'change',
      preferenceChanged
    );

  } else {

    motionPreference.addListener(
      preferenceChanged
    );

  }

})();